import { Helmet } from "react-helmet-async";

const TermsOfService = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Helmet>
        <title>My Church Directory Terms of Service | Online Church Directory Software</title>

        <meta
          name="description"
          content="Explore powerful church directory features including member management, mobile apps, email and text messaging, printable directories, and secure online access. Manage your church directory with ease."
        />
      </Helmet>

      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 py-20 text-center">

          <span className="inline-flex rounded-full bg-sky-100 text-sky-700 px-4 py-1 text-sm font-medium">
            Legal
          </span>

          <h1 className="different_heading mt-5 text-4xl lg:text-5xl font-bold text-slate-900">
            Terms of Service
          </h1>

          <p className="mt-6 max-w-3xl mx-auto text-lg text-slate-600 leading-8">
            Please read these terms carefully before using My Church Directory.
            They explain your rights, responsibilities, and how our services work.
          </p>

        </div>
      </section>

      {/* Terms */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 space-y-6">

          {[
            {
              title: "Introduction",
              content:
                "By using My Church Directory, you agree to these Terms of Service and our policies.",
            },
            {
              title: "Membership",
              content:
                "Enjoy a free 30-day trial with full access. Continue by upgrading to a paid subscription or your account will expire automatically.",
            },
            {
              title: "Promotional Offers",
              content:
                "Special offers may be available from time to time and are subject to their individual terms and eligibility.",
            },
            {
              title: "Billing & Cancellation",
              content:
                "Subscriptions renew automatically until canceled. You can update payment details or cancel your membership anytime from your account.",
            },
            {
              title: "Content & Usage",
              content:
                "All platform content belongs to My Church Directory. Users may not misuse, copy, or interfere with the service.",
            },
            {
              title: "Copyright",
              content:
                "Directories may be reproduced only for use within your church or organization according to our copyright policy.",
            },
            {
              title: "Paperless Billing",
              content:
                "Invoices and billing notifications are delivered electronically. Please keep your email address up to date.",
            },
            {
              title: "Push Notifications",
              content:
                "Members can opt in to receive notifications for updates, reminders, and important announcements. Notification preferences can be managed at any time.",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="rounded-2xl bg-white border border-slate-200 shadow-sm p-8"
            >
              <div className="flex items-center gap-4 mb-4">

                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary text-white font-semibold">
                  {index + 1}
                </div>

                <h2 className="text-2xl font-bold text-slate-900">
                  {item.title}
                </h2>

              </div>

              <p className="text-slate-600 leading-8">
                {item.content}
              </p>
            </div>
          ))}

        </div>
      </section>

      {/* Important Notice */}

      <section className="pb-20">
        <div className="max-w-5xl mx-auto px-6">

          <div className="rounded-3xl bg-secondary text-white p-10">

            <h2 className="different_heading text-3xl font-bold">
              Important Notice
            </h2>

            <p className="mt-4 text-sky-100 leading-8">
              These Terms of Service may be updated from time to time. Continued
              use of My Church Directory after any changes means you agree to the
              updated terms.
            </p>

          </div>

        </div>
      </section>

    </div>
  );
};

export default TermsOfService;